import loadable from "@loadable/component";
import AEMWrapper from "aem/ComponentWrapper";
import React, { memo, useState } from "react";
import meta from "./aem-meta";
import { useMediaQuery } from "@RHCommerceDev/hooks/useMediaQuery";
import { BREAKPOINT_SM } from "utils/constants";

export const FallbackComponent = props => {
  const xl = useMediaQuery(`(min-width: ${BREAKPOINT_SM}px)`);
  const [maxHeightValue] = useState<number | "auto">(xl ? "auto" : 300);

  return (
    <div
      style={{
        height: props.placeholderHeight || "1000px",
        background: "black",
        maxHeight: maxHeightValue
      }}
    ></div>
  );
};

const Component = loadable(
  () =>
    import(
      /* webpackChunkName: "component-media-player/aem-component" */ "./index"
    ),
  {
    fallback: <FallbackComponent />
    //we're going to test this with SSR now with the new configuration
    //ssr: false /* this component throws  a lot of errors on server side  */
  }
);

export default memo(AEMWrapper(meta, Component));
